import axios from 'axios';
import { createAsyncThunk } from '@reduxjs/toolkit';

import {
  GETTING_USER_EMPLOYMENT_INFO,
  CREATING_USER_EMPLOYMENT_INFO,
  PATCHING_USER_EMPLOYMENT_INFO,
  UPDATE_USER_EMPLOYMENT_INFO,
} from './actionTypes';

import { API_ENDPOINT } from '../constants';

// CONFIRM EMPLOYMENT INFO MODAL
export const updateUserEmploymentInfo = (dispatch, employmentInfo) => {
  dispatch({ type: UPDATE_USER_EMPLOYMENT_INFO, payload: employmentInfo });
};

// Get User Employment Info
export const getUserEmploymentInfo = createAsyncThunk(
  GETTING_USER_EMPLOYMENT_INFO,
  async ({ id, tokenValue }, methods) => {
    const { dispatch } = methods;
    let response;
    try {
      dispatch({ type: GETTING_USER_EMPLOYMENT_INFO });
      const res = await axios.get(`${API_ENDPOINT}/users/${id}/employment`, {
        headers: {
          Authorization: `Bearer ${tokenValue}`,
        },
      });
      response = res?.data || {};
    } catch (error) {
      console.error(error);
    }

    dispatch((dispatch) => updateUserEmploymentInfo(dispatch, response));
  },
);

export const createUserEmploymentInfo = createAsyncThunk(
  CREATING_USER_EMPLOYMENT_INFO,
  async ({ employmentInfo, tokenValue }, methods) => {
    const { dispatch } = methods;
    let response;
    try {
      const res = await axios.post(
        `${API_ENDPOINT}/employment/new`,
        {
          employmentInfo: {
            ...employmentInfo,
            jobDurationYears: employmentInfo['Job Duration']?.['Years'],
            jobDurationMonths: employmentInfo['Job Duration']?.['Months'],
          },
          model: 'employment',
        },
        {
          headers: {
            Authorization: `Bearer ${tokenValue}`,
          },
        },
      );

      response = res?.data || {};
    } catch (error) {
      console.error(error);
    }

    updateUserEmploymentInfo(dispatch, response);
  },
);

export const patchUserEmploymentInfo = createAsyncThunk(
  PATCHING_USER_EMPLOYMENT_INFO,
  async ({ employmentInfo, tokenValue }, methods) => {
    const { dispatch } = methods;
    let response;

    try {
      const res = await axios.patch(
        `${API_ENDPOINT}/employment/${employmentInfo.id}`,
        {
          employmentInfo: {
            ...employmentInfo,
            jobDurationYears: employmentInfo['Job Duration']?.['Years'],
            jobDurationMonths: employmentInfo['Job Duration']?.['Months'],
          },
          model: 'employment',
        },
        {
          headers: {
            Authorization: `Bearer ${tokenValue}`,
          },
        },
      );
      response = res?.data || {};
    } catch (error) {
      console.error(error);
    }

    updateUserEmploymentInfo(dispatch, response);
  },
);
